<template>
  <MoleculeEditionUpdatingLicence/>
</template>

<script>
export default {
  name: 'OrganismUpdatingLicence',

  components: {
    MoleculeEditionUpdatingLicence: () => import('@/components/molecules/MoleculeEditionUpdatingLicence')
  }
}
</script>
